import React, { PureComponent } from 'react';

import { DataTable } from 'components/dataTable';
import Compare from 'helpers/Compare';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';

import './ContentList.scss';

export default class ContentList extends PureComponent {
  static propTypes = {
    items: PropTypes.array,
    loading: PropTypes.bool,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        type: PropTypes.oneOf(Object.values(Compare.DATA_TYPES)),
        defaultOrderBy: PropTypes.oneOf(Object.values(Compare.ORDER_BY))
      })
    ).isRequired,
    defaultSortOptions: PropTypes.arrayOf(PropTypes.object)
  };

  state = {
    sortOptions: {
      ...this.props.defaultSortOptions
    }
  };

  saveSortData = (selectedSortOption) => {
    const { defaultSortOptions } = this.props;
    const sortOptions = { ...defaultSortOptions, ...selectedSortOption };

    this.setState({ sortOptions });

    return sortOptions;
  };

  customSortField(sortFields = []) {
    const { defaultSortOptions } = this.props;
    const defaultSortField =
      defaultSortOptions && Object.keys(defaultSortOptions)[0];

    return sortFields.find((field) => field !== defaultSortField);
  }

  primarySortField(sortOptions = {}) {
    const sortFields = sortOptions && Object.keys(sortOptions);

    if (!sortFields) {
      return null;
    }

    return sortFields.length > 1
      ? this.customSortField(sortFields)
      : sortFields[0];
  }

  get items() {
    const { items, columns } = this.props;
    const { sortOptions } = this.state;
    const sortField = this.primarySortField(sortOptions);
    let newItems = cloneDeep(items);

    const column =
      sortField && columns.find((column) => column.name === sortField);

    if (column && column.type) {
      const dataType = column.type;

      newItems = newItems.sort((item1, item2) => {
        const a = item1[sortField];
        const b = item2[sortField];
        const ordeBy = sortOptions[sortField];

        return Compare.compare(a, b, ordeBy, dataType);
      });
    }

    return newItems;
  }

  get itemsLength() {
    const { items } = this.props;

    return items ? items.length : 0;
  }

  render() {
    const { loading, columns } = this.props;
    const { sortOptions } = this.state;

    return (
      <DataTable
        sortOptions={sortOptions}
        columns={columns}
        items={this.items}
        loading={loading}
        pagination={{ totalElements: this.itemsLength }}
        onChangeSort={this.saveSortData}
        className="content__list"
      >
        <DataTable.Header className="list__header" />
        <DataTable.Body className="list__body" />
      </DataTable>
    );
  }
}
